import styled from 'styled-components';
import Button from 'components/Button';

export const Container = styled.div`
  display: flex;
  margin-top: 10px;
  padding: 0 30px;
  flex-shrink: 0;
`;

export const Title = styled.div`
  width: 150px;
  font-weight: 600;
  flex-shrink: 0;
`;

export const Column = styled.div`
  display: flex;
  flex: 1;
  flex-grow: 0;
  flex-direction: column;
`;

export const RatedAt = styled.div`
  font-size: 12px;
  font-weight: 400;
  margin-top: -15px;
  color: ${({ theme }) => theme.darkGrey};
`;

export const StyledButton = styled(Button)`
  margin-left: 20px;
  background: #f2f2f2;
  text-transform: none;
  font-size: 12px;
  font-weight: 400;
  color: #000;
  border: 1px solid #ccc;
  padding: 8px 0;
  flex: 1;
  border-radius: 5px;
  height: 100%;
`;
